<template>
  <HotelArtworkLayout :head-title="headTitle">
    <template v-slot:imageSlot>
      <div class="hotel-box-image" ref="imageDom">
        <img class="room-image" ref="imgFood" :src="imgSrc ? imgSrc : image" alt="">
        <div class="content-center">
          <div class="box-detail">
          </div>
        </div>
        <div class="content-top">
          <div class="box-logo">
            <img v-if="imgLogoLeftSrc" class="logo-left" ref="imgLogo" :src="imgLogoLeftSrc" alt="">
            <img v-if="imgLogoRightSrc" class="logo-right" ref="imgLogo" :src="imgLogoRightSrc" alt="">
          </div>
        </div>
        <div class="content-bottom">
          <div class="box-detail">
            <gen-left-icon-bg-component
              :inputText="locationName"
              :previewOptions="storeOptions1"
              :textLeft="textLeft"
              :start-color="startColor"
              :end-color="endColor"
              :shadow-color="shadowColor"
            ></gen-left-icon-bg-component>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:formSlot>
      <div class="box-form">
        <input type="file" @change="onFileChanged" class="hidden-files" ref="addFile">
        <button class="btn-color change-pic" @click="onUpload">{{ btn_upload_label }}</button>

        <div class="box-label">
          <label class="label-left">{{ $t('LOGO_LEFT') }}</label>
        </div>
        <div class="box-input-file">
          <div class="half">
            <div class="border-linear">
              <input type="file" @change="onLogoLeftFileChanged" class="hidden-files" ref="addFileLogoLeft"/>
              <input type="text" disabled v-model="imgLogoLeftSrcName" :placeholder="$t('INSERT_LOGO_LEFT_LABEL')"/>
            </div>
          </div>
          <div class="half-btn">
            <div class="border-linear">
              <button v-if="imgLogoLeftSrc" class="btn-color btn-logo-input" @click="onRemoveLogoLeft">{{ $t('REMOVE_IMAGE_LABEL') }}</button>
              <button v-else class="btn-color btn-logo-input" @click="onUploadLogoLeft">{{ btn_upload_logo_left_label }}</button>
            </div>
          </div>
        </div>

        <div class="box-label">
          <label class="label-left">{{ $t('LOGO_RIGHT') }}</label>
        </div>
        <div class="box-input-file">
          <div class="half">
            <div class="border-linear">
              <input type="file" @change="onLogoRightFileChanged" class="hidden-files" ref="addFileLogoRight"/>
              <input type="text" disabled v-model="imgLogoRightSrcName" :placeholder="$t('INSERT_LOGO_RIGHT_LABEL')"/>
            </div>
          </div>
          <div class="half-btn">
            <div class="border-linear">
              <button v-if="imgLogoRightSrc" class="btn-color btn-logo-input" @click="onRemoveLogoRight">{{ $t('REMOVE_IMAGE_LABEL') }}</button>
              <button v-else class="btn-color btn-logo-input" @click="onUploadLogoRight">{{ btn_upload_logo_right_label }}</button>
            </div>
          </div>
        </div>

        <div class="box-label">
          <label class="label-left">{{ $t('LOCATION_NAME') }}</label>
          <label class="label-right">
            <span v-text="locationName.length"></span><span ref="maximum_branch">{{ `/${ $t('HOTEL_NAME_LIMIT') }` }}</span>
          </label>
        </div>

        <div class="border-linear">
          <input type="text" :maxlength="$t('HOTEL_NAME_LIMIT')" v-model="locationName" :placeholder="$t('INSERT_LOCATION_NAME_LABEL')"/>
        </div>

        <div class="box-label">
          <label class="label-left">{{ $t('PIN_COLOR') }}</label>
        </div>
        <div class="box-input-file">
          <div class="half color">
            <div class="border-linear">
              <color-picker v-model="startColor"></color-picker>
            </div>
          </div>
          <div class="half color">
            <div class="border-linear">
              <color-picker v-model="endColor"></color-picker>
            </div>
          </div>
        </div>

        <div class="box-label">
          <label class="label-left">{{ $t('SHADOW_COLOR') }}</label>
        </div>
        <div class="border-linear">
          <color-picker v-model="shadowColor"></color-picker>
        </div>

        <div class="back" id="open_update" @click="toggleBackPopup">
          <div><p>{{ $t('BACK_LABEL') }}</p></div>
        </div>
        <button class="btn-color save-pic" ref="save_pic" @click="toImage">{{ $t('SAVE_IMAGE_LABEL') }}</button>

        <div :class="['popup-saved', 'animatedFadeInUp', 'animated', savedPopupClass]" id="popup-saved">
          <p>{{ $t('SAVE_IMAGE_ALREADY_LABEL') }}</p>
          <img src="@/assets/img/icons/akar-icons_circle-check.png" alt=""/>
        </div>
        <div :class="['popup-back', backPopupClass]">
          <BackPopup :toggleBackPopup="toggleBackPopup" />
        </div>
      </div>
    </template>
  </HotelArtworkLayout>
</template>

<script>
import HotelArtworkLayout from '@/layouts/HotelArtworkLayout.vue';
import BackPopup from '@/components/Popup/BackPopup.vue';
import { qrCodeFoodSize, qrCodeFoodSizeM } from '@/config/enum';
import { generateImageAndDownload } from '@/utils';
import bgEmptyHotel from '@/assets/img/background/BG_OTA.png';
import generateTextLeftIconBackground
  from '@/components/GenerateText/GenerateTextLeftIconBackground.vue';

export default {
  name: 'HotelAds',
  metaInfo: {
    title: 'Hotel Ads',
  },
  components: {
    HotelArtworkLayout,
    BackPopup,
    // eslint-disable-next-line vue/no-unused-components
    genLeftIconBgComponent: generateTextLeftIconBackground,
  },
  props: {
    headTitle: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const windowSize = {
      target: {
        innerWidth: window.innerWidth,
      },
    };
    this.onResize(windowSize);
  },
  data() {
    return {
      shadowColor: '#ffffff',
      startColor: '#CF1E9E',
      endColor: '#7F50B2',
      degree: 0,

      screenWidth: 0,
      imgSrc: '',
      imgSrcName: 'RBH_shop.jpg',

      imgLogoLeftSrc: '',
      imgLogoLeftSrcName: '',

      imgLogoRightSrc: '',
      imgLogoRightSrcName: '',

      qrCodeSize: qrCodeFoodSize,
      qrCodeSizeM: qrCodeFoodSizeM,
      qtyOptionsDesktop: {
        safeWidth: 450,
        previewHeight: 240,
        previewVertOffset: 0,
        originalFontSize: 198,
      },
      qtyOptionsMobile: {
        safeWidth: 360,
        previewHeight: 120,
        previewVertOffset: 0,
        originalFontSize: 120,
      },

      storeOptions1: {
        safeWidth: 1100,
        previewHeight: 120,
        previewVertOffset: 0,
        originalFontSize: 18,
      },

      textLeft: 25,
      isIcon: 'location',
      fixText: '',

      roomTypeName: '',
      locationName: '',
      btn_upload_label: this.$t('UPLOAD_IMAGE_LABEL'),
      btn_upload_logo_left_label: this.$t('UPLOAD_IMAGE_LABEL'),
      btn_upload_logo_right_label: this.$t('UPLOAD_IMAGE_LABEL'),

      image: bgEmptyHotel,
      isShowBackPopup: false,
      isShowSavedPopup: false,
      isShowIntroducePopup: false,
      isShowShadow: false,
    };
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    backPopupClass() {
      return this.isShowBackPopup ? 'popup-show' : '';
    },
    savedPopupClass() {
      return this.isShowSavedPopup ? 'fadeInUp' : '';
    },
  },
  methods: {
    rotate(name, degree) {
      // document.documentElement.style.setProperty(`--${name}`, degree);
      console.log(name, degree);
      this.degree = degree;
    },
    onResize(e) {
      this.screenWidth = e.target.innerWidth;
    },
    toggleIntroducePopup() {
      this.isShowIntroducePopup = !this.isShowIntroducePopup;
    },
    toggleBackPopup() {
      this.isShowBackPopup = !this.isShowBackPopup;
    },
    onFileChanged(e) {
      this.btn_upload_label = this.$t('CHANGE_IMAGE_LABEL');
      this.isShowShadow = true;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0], 'bg');
    },
    onLogoLeftFileChanged(e) {
      this.btn_upload_logo_left_label = this.$t('CHANGE_IMAGE_LABEL');
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0], 'logo-left');
    },
    onLogoRightFileChanged(e) {
      this.btn_upload_logo_right_label = this.$t('CHANGE_IMAGE_LABEL');
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0], 'logo-right');
    },
    createImage(file, type) {
      // const image = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        const image = e.target && e.target.result ? e.target.result : '';
        if (typeof image === 'string') {
          if (type === 'bg') {
            this.imgSrc = image;
            this.imgSrcName = file.name;
          } else if (type === 'logo-left') {
            this.imgLogoLeftSrc = image;
            this.imgLogoLeftSrcName = file.name;
          } else if (type === 'logo-right') {
            this.imgLogoRightSrc = image;
            this.imgLogoRightSrcName = file.name;
          }
        }
      };

      reader.readAsDataURL(file);
    },
    toImage() {
      const imageNode = this.$refs.imageDom;
      this.generateImageAndDownload(imageNode, window.innerWidth <= 767 ? 400 : 520);
    },
    onSave() {
      this.isShowSavedPopup = true;
      setTimeout(() => {
        this.isShowSavedPopup = false;
      }, 3000);
    },
    generateImageAndDownload(imageNode, size) {
      generateImageAndDownload(imageNode, size, this.imgSrcName, this.onSave);
    },
    onUpload() {
      this.$refs.addFile.click();
    },
    onUploadLogoLeft() {
      this.$refs.addFileLogoLeft.click();
    },
    onUploadLogoRight() {
      this.$refs.addFileLogoRight.click();
    },
    onRemoveLogoRight() {
      this.imgLogoRightSrc = '';
      this.imgLogoRightSrcName = '';
      this.btn_upload_logo_right_label = this.$t('UPLOAD_IMAGE_LABEL');
    },
    onRemoveLogoLeft() {
      this.imgLogoLeftSrc = '';
      this.imgLogoLeftSrcName = '';
      this.btn_upload_logo_left_label = this.$t('UPLOAD_IMAGE_LABEL');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../assets/sass/media-query";

.box-input-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 380px;

  @include max-large-tablet{
    max-width: 100%;
  }

  .half {
    width: 60% !important;

    &.color {
      width: 40% !important;
    }

    &-btn {
      width: fit-content !important;
      display: block;
      float: left;

      .btn-logo-input {
        margin-bottom: unset;
        font-size: 18px;
        display: block;
      }

      .border-linear {
        border-radius: 25px;
        padding: 0 5px;
        justify-content: center;
      }
    }
  }
}

.one-colorpicker {
  width: 100%;

  ::v-deep .color-block {
    width: 100%;
    .color-block-layer {
      border-radius: 10px;
    }
  }
}
</style>
